import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS } from 'styles/constants';
import { Theme } from '../types';

export const CustomFormulaContainer = styled.div<{ themeType: Theme }>`
  position: relative;

  background: ${({ themeType }) =>
    themeType === 'primary' ? LOCAL_COLORS.surfaceWhite : '#DCD6C6'};
  }
`;

export const DesktopBackgroundContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;

  * {
    width: 100%;
    height: 100%;
  }
`;

export const InnerBox = styled.div<{ themeType: Theme }>`
  padding: ${SPACER.medium};
  position: relative;
  display: block;

  ${MEDIA_QUERIES.mdUp} {
    display: flex;
    flex-direction: column;
    gap: 24px;

    ${({ themeType }) =>
      themeType !== 'primary' ? 'align-items: flex-end;' : ''}

    padding: 7rem ${SPACER.xlarge};
    padding-bottom: ${SPACER.x2large};
  }

  ${MEDIA_QUERIES.lgUp} {
    padding: 7rem 4.5rem;
    padding-bottom: 80px;
  }

  ${MEDIA_QUERIES.xlUp} {
    max-width: 1296px;
    margin: auto;
  }
`;

export const LeftContent = styled.div`
  background-color: ${LOCAL_COLORS.surfaceWhite};
  padding: ${SPACER.large} ${SPACER.medium} 0px;

  ${MEDIA_QUERIES.mdUp} {
    width: 50%;
    max-width: 550px;
    padding: ${SPACER.xlarge};
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Title = styled.h2`
  font-size: 32px;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -1.6px;
  margin-bottom: ${SPACER.large};

  sup {
    font-size: 65%;
  }

  ${MEDIA_QUERIES.mdUp} {
    font-size: 52px;
  }
`;

export const Subtitle = styled.div`
  line-height: 22px;
  font-size: 15px;
  font-weight: 700;
`;

export const TagHeadline = styled.div`
  font-weight: 700;
  line-height: 150%;
  padding-top: ${SPACER.large};
  padding-bottom: ${SPACER.medium};
`;

export const Tags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: ${SPACER.large};
`;

export const Tag = styled.li`
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  background-color: ${LOCAL_COLORS.orange500};
  width: fit-content;
  padding: 1px 5px;
`;

export const Price = styled.div`
  line-height: 150%;
  padding-bottom: ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    padding-bottom: ${SPACER.x3large};
  }
`;

export const ctaStyles = css`
  max-width: none;

  ${MEDIA_QUERIES.mdUp} {
    width: 100%;
  }

  button {
    font-size: 16px;
    line-height: 132%;
    letter-spacing: -0.32px;
  }
`;

export const Disclaimer = styled.div`
  font-size: 14px;
  line-height: 140%;
  padding: ${SPACER.medium} 0;

  a {
    text-decoration: underline;
  }
`;

export const ValuePropContainer = styled.div`
  background: ${LOCAL_COLORS.surfaceWhite};
  color: ${LOCAL_COLORS.surfaceDarkBold};
  width: 100%;
  margin-top: ${SPACER.medium};
  padding: ${SPACER.large} ${SPACER.medium};
  display: flex;
  gap: 6px;

  ${MEDIA_QUERIES.mdUp} {
    width: 50%;
    max-width: 550px;
    margin-top: 0;
    padding: ${SPACER.xlarge};
  }
`;

export const SVGContainer = styled.div`
  padding-top: ${SPACER.x2small};

  svg {
    align-self: center;
  }
`;

export const ValueProp = styled.div`
  font-size: ${SPACER.medium};
  font-weight: 700;
  line-height: 130%;
`;
